import { createFileRoute } from '@tanstack/react-router';
import { AdminBillingPage } from '@/components/admin/admin-billing';

export const Route = createFileRoute('/admin/billing')({
  component: AdminBillingPage,
});
